const ERROR = 'pulp/finalise/ERROR';
const CLEAR = 'pulp/finalise/CLEAR';

export const initialState = {
  error: null,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case ERROR:
      return {
        ...state,
        error: action.payload,
      };
    case CLEAR:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
}

export function error(payload) {
  return {
    type: ERROR,
    payload,
  };
}

export function clearError() {
  return {
    type: CLEAR,
  };
}